<template>
  <div class="post ql-snow">
    <div class="post-left" v-if="post">
      <div class="post-title">{{post.title}}</div>
      <section v-if="post && post.post" class="post-header">
        <span style="margin-left: 0;">发布时间: {{post.post.updated_at.day}}</span>
        <img style="margin-left:37px" :src="seeUrl" />
        <span>{{post.post.pageview}}</span>
        <img style="margin-left: 30px;" :src="likeUrl" />
        <span>{{post.likeUsers && post.likeUsers.length}}</span>
      </section>
      <article v-html="post.post && post.post.post" class="post-content ql-editor"></article>
      <attachment v-if="post && post.post && post.post.sourceFile" :sourceFile="post.post.sourceFile" :id="post.post.id"  />
      <div class="post-tags" v-if="post.post"><span v-for="item in post.post.tags" :key="item.value">{{item.label}}</span></div>
      <div class="post-like">
        <div v-if="post && post.isLike && isLike" class="post-btn post-islike-btn" key="isLike">
          <i class="iconcool iconcool-like"/>
          <span>{{post && post.isLike && isLike ? likeContent: unLikeContent}}</span>
        </div>
        <div class="post-btn post-unlike-btn"  v-else @click="likeArticle" key="unLike">
          <img v-if="showGif" :src="likeGifUrl">
          <i v-else class="iconcool iconcool-like"/>
          <span >点赞</span>
        </div>
      </div>
      <div class="post-share" v-if="post.post">
        <div><span><span style="color: #E70012">{{post.likeUsers && post.likeUsers.length}} </span>个人觉得很赞</span> </div>
        <div class="post-share-footer">
          <div class="post-share-icons">
            <el-tooltip content="分享到微信" placement="top" effect="light">
              <img @click="shareWechat" :src="wechatUrl" />
             </el-tooltip>
            <el-tooltip style="margin-left: 18px;" content="复制链接" placement="top" effect="light">
              <img :src="ligthUrl" id="copy" @click="copyLink" :data-clipboard-text="url" />
             </el-tooltip>
          </div>
          <div class="like-users">
             <transition-group name="list" tag="div">
               <img v-for="item in post.likeUsers.slice(0, Math.min(post.likeUsers.length, 5))" :src="item.avatar" :key="item.uid" />
             </transition-group>
          </div>
          <el-tooltip style="margin-left: 58px;" content="回到顶部" placement="top" effect="light">
            <div class="post-up">
              <i class="el-icon-arrow-up" @click="scrollTop" style="color: #ffffff;"></i>
            </div>
          </el-tooltip>
        </div>
      </div>
      <div class="post-comment-title"><span>参与评论</span></div>
      <Comment :head="true" commentListIndex="author" />
      <comment-list v-if="post && post.post" style="margin-top: 31px;" :id="post.post._id" :comments="post.post.comments"  />
    </div>
    <div class="post-right">
      <user-card :user="post.post && post.post.user" />
      <course-rate style="margin-top: 40px;" :isCourse="false" :courses="post.posts" />
    </div>
  </div>
</template>
<script>
import {mapGetters, mapActions} from 'vuex'
import CourseRate from '@/components/course/CourseRate'
import Attachment from '@/components/common/Attachment'
import ClipboardJS from 'clipboard'
import Comment from '@/components/post/Comment';
import CommentList from '@/components/post/CommentList';
import UserCard from '@/components/common/UserCard'
import see from '@/assets/img/see.png'
import like from '@/assets/img/like.png'
import likeGif from '@/assets/img/like.gif'
import likewhite from '@/assets/img/likewhite.png'
import light1 from '@/assets/img/light1.png'
import light2 from '@/assets/img/light2.png'
import wechat1 from '@/assets/img/wechat1.png'
import wechat2 from '@/assets/img/wechat2.png'
import QR from '@/components/common/qr'
export default {
  name: 'post',
  data () {
    return {
      seeUrl: see,
      likeUrl: like,
      likewhiteUrl: likewhite,
      likeGifUrl: likeGif,
      likeIconUrl: likewhite,
      ligthUrl: light1,
      wechatUrl: wechat1,
      isLike: true,
      showGif: false,
      likeContent: '已点赞',
      unLikeContent: '点赞'
    }
  },
  components: {
    UserCard, Comment, CommentList, Attachment, CourseRate
  },
  async created () {
    let post = await this.getPost(this.$route.params.id)
    if(!this.$route.query.articleType) {
      const path = this.$route.path
      const query = this.$route.query
      this.$router.push({
        path,
        query: {...query, articleType: post.post.category2[0]._id}
      })
    }
  },
  mounted () {
    new ClipboardJS('#copy');
  },
  computed: {
    ...mapGetters('home', ['user']),
    ...mapGetters('post', ['post', 'attachMent']),
    url () {
      return location.href
    }
  },
  methods: {
    ...mapActions('post', ['getPost', 'likePost']),
    likeArticle () {
      if(!this.user) {
        this.isLogin('登录后点赞')
        return
      }
      // this.isLike = false
      this.showGif =  true
      setTimeout(() =>{
        this.showGif = false
        // document.querySelector('#post-like-btn').className += ' post-islike-btn'
        // document.querySelector('#like').innerHTML = '点赞'
      }, 1000)
      this.likePost({uid: this.user.uid, id: this.post.post.id})
    },
    copyLink () {
      this.ligthUrl = light2
      this.$message({message: '拷贝成功，现在可以分享该链接', onClose: () => {
        this.ligthUrl = light1
      }})
    },
    shareWechat () {
      this.wechatUrl = wechat2
      QR.open(() => {
        this.wechatUrl = wechat1
      })
    },
    scrollTop () {
      window.scroll({
        top: 0,
        left: 0,
        behavior: 'smooth'
      })
    }
  },
}
</script>
<style lang="scss">
@media screen and (max-width: 1000px) {
  .post-right {
    display: none;
    overflow-x: hidden;
  }
  .post-left {
    margin: 0 65px;
  }
  .ql-snow {
    overflow: hidden;
  }
}
.post {
  padding-top: 40px;
  text-align: left;
  display: flex;
  justify-content: space-between;
  >.post-left {
    width: 850px;
     >.post-title {
      font-size:28px;
      font-family:MicrosoftYaHei-Bold;
      font-weight:bold;
      color:rgba(51,51,51,1);
      margin-bottom: 30px;
    }
    >.post-header {
      color: #999999;
      display: flex;
      align-items: center;
      >*{
        margin-left: 4px;
      }
      >img{
        width: 20px;
      }
    }
    >.post-content {
      padding-left: 0;
      padding-bottom: 5px;
      height: auto;
    }
    >.post-tags {
      >span {
        display: inline-block;
        min-width: 68px;
        padding: 0 13px;
        height: 32px;
        line-height: 32px;
        background:rgba(248,248,248,1);
        border-radius:2px;
        margin-right: 8px;
        font-size:14px;
        color:rgba(51,51,51,1);
      }
    }
    >.post-like {
      display: flex;
      flex-direction: column;
      align-items: center;
      margin: 45px auto 53px;
      >.post-btn {
        position: relative;
        width:134px;
        height:59px;
        border-radius:30px;
        font-size:16px;
        font-family:MicrosoftYaHei-Bold;
        font-weight:bold;
        line-height:24px;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: space-around;
        padding: 12px 0;
        transition: 2s;
        >:first-child {
          position: absolute;
          top: 5px;
        }
        >img {
          width: 44px;
          height: 44px;
          top: -5px !important;
        }
        >:nth-child(2) {
          position: absolute;
          bottom: 5px;
        }
        &:hover {
          cursor: pointer;
        }
      }
      >.post-unlike-btn {
        background:linear-gradient(90deg,rgba(231,0,18,1) 0%,rgba(255,134,7,1) 100%);
        color:rgba(255,255,255,1);
      }
      >.post-islike-btn {
        background: rgba(248,248,248,1);
        color: #999999;
      }
    }
    >.post-share {
      height:105px;
      padding: 12px 30px;
      background:rgba(248,248,248,1);
      border-radius:6px;
      text-align: center;
      font-size:12px;
      font-family:MicrosoftYaHei-Bold;
      font-weight:bold;
      line-height:24px;
      >.post-share-footer {
        height: 51px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        >.post-share-icons {
          >img {
            width: 40px;
            height: 40px;
          }
        }
        .like-users {
          img {
            width: 43px;
            height: 43px;
            border-radius: 50%;
            margin: 0 4px;
          }
        }
        >.post-up {
          width: 40px;
          height: 40px;
          line-height: 40px;
          border-radius: 20px;
          background: #d8d8d8;
          display: flex;
          align-items: center;
          justify-content: space-around;
          >i {
            font-size: 22px;
            position: relative;
            top: -2px;
            &:hover{
              cursor: pointer;
            }
          }
        }
      }
    }
    >.post-comment-title {
      padding: 20px 0;
      border-bottom:1px solid #Eaeaea;
      margin-bottom: 15px;
      >span {
        display: inline-block;
        font-size:16px;
        font-family:MicrosoftYaHei-Bold;
        font-weight:bold;
        color:rgba(51,51,51,1);
        line-height:16px;
        height: 16px;;
        padding-left: 10px;
        border-left: 4px solid #E70012;
      }
    }
  }
  >.post-right {
    width: 280px;
  }
}
</style>
<style lang="scss">
.post {
  iframe {
    overflow: hidden;
    height: 535px;
    width: 100%;
  }
}
</style>


